import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import '@/design-system/fonts';
import '@/design-system/tokens.css';
import '@/design-system/typography.css';
import '@/styles/global.css';
import { router } from '@/app/router';
import { PreviewProvider } from '@/features/access/PreviewProvider';
import { AuthProvider } from '@/features/auth/AuthProvider';
import { JourneyProvider } from '@/features/journey/JourneyProvider';
import { ThemeProvider } from '@/features/theme/ThemeProvider';
import { I18nProvider } from '@/i18n/I18nProvider';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element in index.html');

// AuthProvider reads the language context, so I18nProvider must wrap it.
// JourneyProvider sits above the router so the chosen vehicle/interests/
// service survive navigation to the (route-level) auth layout and back.
createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <PreviewProvider>
            <JourneyProvider>
              <RouterProvider router={router} />
            </JourneyProvider>
          </PreviewProvider>
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
);
